const Textarea = {
  variants: {
    chatComposer: {
      bg: "dark.400",
      color: "gray.50",
      // Safari zooms the viewport when focusing an input below 16px (md), which
      // no width breakpoint covers reliably: md matches iPad portrait exactly.
      fontSize: "xs",
      "@media (pointer: coarse)": {
        fontSize: "md",
      },
      borderRadius: "6px",
      border: "2px solid",
      borderColor: "transparent",
      _focus: {
        border: "2px solid",
        borderColor: "purple.300",
      },
      _placeholder: {
        color: "dark.100",
      },
    },
  },
};

export default Textarea;
